// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BlockedAddressController from "./blocked_address_controller.js"
application.register("blocked-address", BlockedAddressController)

import DomainController from "./domain_controller.js"
application.register("domain", DomainController)

import InboundController from "./inbound_controller.js"
application.register("inbound", InboundController)

import EmailPreviewController from "./email_preview_controller"
application.register("email-preview", EmailPreviewController)

import OutgoingEmailController from "./outgoing_email_controller.js"
application.register("outgoing-email", OutgoingEmailController)

import Shared__ToastFlashController from "./shared/toast_flash_controller.js"
application.register("shared--toast-flash", Shared__ToastFlashController)

import Webauthn__AuthController from "./webauthn/auth_controller.js"
application.register("webauthn--auth", Webauthn__AuthController)

import Webauthn__RegisterController from "./webauthn/register_controller.js"
application.register("webauthn--register", Webauthn__RegisterController)
